

























































import { Component, Vue } from 'vue-property-decorator'
import { State, Action, Getter } from 'vuex-class'
import t from '@/i18n/translations'
import report from '@/api/report';
import _ from 'lodash';

import {
    CurrentStepTitle,
    SFSelect,
    SFRadio,
    SFInput,
    BoxHeading,
    ProgressFooter
    } from '@/components'

const namespace = 'reports';
const ns_user = { namespace: 'user' };

@Component({
    components: {
        CurrentStepTitle,
        SFSelect,
        SFRadio,
        SFInput,
        BoxHeading,
        ProgressFooter
    },
    props: ['config', 'data']
})

export default class SFGrid extends Vue {
    
    @Getter('getUserInfo',  ns_user ) getUserInfo: any;

    i18n = t['nl'];

    fillColor = "#ff0000";

    reports: any = [];
    displayedRecords: any = [];
    paginatedReports: any = [];
    currentSort: string = 'company_name';
    currentSortDir: string = "asc";
    pageSize: number = 20;
    currentPage: number = 1;
    pagesLength: number = 1;
    paginationButtonsLength: number = 1;
    moreButtonsForward: boolean = false;
    moreButtonsBackward: boolean = false;
    lastPage: boolean = false;
    paginationSet: number[] = [];
    paginationCounter: number = 1;
    isAdmin: boolean = false;

    mounted() {
        this.reports = [...this.$props.data];
        this.setReportsLengthPerPage(this.pageSize);
        this.checkIfAdmin();

        if (this.reports.length % this.pageSize !== 0) {
            this.pagesLength = Math.floor( (this.reports.length / this.pageSize) + 1);
        } else if (this.reports.length % this.pageSize === 0) {
            this.pagesLength = Math.floor(this.reports.length / this.pageSize);
        } else {
            this.pagesLength = 0;
        }

        if (this.pagesLength > 4) {
            this.paginationButtonsLength = 3;
            this.moreButtonsForward = true;
            this.lastPage = true;
        } else {
            this.paginationButtonsLength = this.pagesLength;
        }

        if (this.pagesLength > 0) this.paginationButtonsSet("start");
        this.displayedRecords = this.reports;
    }

    getStatus(points: number): string {
        if (points >= 5000) return 'status--green';
        if (points >= 3000 && points < 5000) return 'status--yellow';
        if (points >= 0 && points < 3000) return 'status--red';

        return 'status--inactive';
    }

    sort(s: string, type: string = "number") {
        if (s === this.currentSort) this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
        this.currentSort = s;
        if (type === "string")
            this.displayedRecords = _.orderBy(this.reports, [item => item[s].toLowerCase()], this.currentSortDir === "asc" ? "asc" : "desc");
        else
            this.displayedRecords = _.orderBy(this.reports, [s], this.currentSortDir === "asc" ? "asc" : "desc");
    }

    sortedReports() {
        return this.displayedRecords.sort((a: any, b:any) => {
            let modifier: number = 1;
            if(this.currentSortDir === 'desc') modifier = -1;
            if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
            if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
            return 0;
        })
    }

    setReportsLengthPerPage(reportsPerPage: number) {
        this.paginatedReports = this.reports.filter( (row: any, index: any) => {
            let start = (this.currentPage - 1) * reportsPerPage;
            let end = this.currentPage * reportsPerPage;
            if(index >= start && index < end) return true;
        });
    }

    displaySelectedPage(selectedPage: number) {
        if(selectedPage === 1) this.paginationButtonsSet("start");
        if(selectedPage === this.pagesLength) this.paginationButtonsSet("last");

        this.currentPage = selectedPage;
        this.setReportsLengthPerPage(this.pageSize);
    }

    paginationButtonsSet(direction: string): void {
        const setLength: number[] = [];

        if(direction === "start") this.paginationCounter = 1;
        if(direction === "last") {
            this.paginationCounter = Math.floor(this.pagesLength / this.pageSize);
            this.moreButtonsForward = false;
        }

        if(direction === "forward") this.paginationCounter++;
        if(direction === "back") this.paginationCounter--;

        this.paginationCounter > 1 ? this.moreButtonsBackward = true : this.moreButtonsBackward = false;

        let multiplier = 3;
        let superMultiplier = multiplier * this.paginationCounter;
        let startCounter = (superMultiplier - multiplier) + 1;

        for(let i = startCounter; i <= superMultiplier; i++) {
            setLength.push(i);
        }

        if(superMultiplier > this.pagesLength) {
            this.moreButtonsForward = false;
            this.lastPage = false;
            this.paginationSet = [1];
        } else if (superMultiplier === this.pagesLength) {
            this.moreButtonsForward = false;
            this.lastPage = false;
            this.paginationSet = setLength;
        } else if (this.pagesLength === 4) {
            this.paginationSet = new Array(1, 2, 3, 4);
        } else {
            this.moreButtonsForward = true;
            this.lastPage = true;
            this.paginationSet = setLength;
        }
    }

    onSearchChange(e:any) {
        const stringVal = e.target.value.toLowerCase();
        const searchable = ['borrowersName', 'branchName'];


        this.displayedRecords = this.reports.filter((el:any) => {
            let ret;
            searchable.forEach(search => {
                if (typeof el[search] !== 'undefined' && el[search] !== null) {
                    if (el[search].toLowerCase().indexOf(stringVal) !== -1 ) {
                        ret = el;
                    }
                }
            });
            return ret;
        })

        if (stringVal=== '') {
            this.paginatedReports = this.reports;
        }
    }

    onHandleDownload(id: string) {
        report.getReportGUID(id).then((resp: any) => {
            report.getReportPDF(resp.data).then((response: any) => {
                const linkSource = `data:application/octet-stream;charset=utf-16le;base64,${response.data}`;
                const downloadLink = document.createElement("a");
                const date = new Date();
                const fileName = `${date.toISOString().slice(0,10)}-report.pdf`;

                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
        })
    }

    checkIfAdmin(): boolean {
        const roles = this.getUserInfo.role.map(role => role.toLowerCase());
        if (roles.indexOf('admin') >= 0) return this.isAdmin = true;
        else return this.isAdmin = false;
    } 
};
